export default __webpack_public_path__ + "static/media/media_new.1ed896fa.jpg";